import type { FaireProductEntity } from "../../entity_types/product";

export const p_3zrzmjrcah: FaireProductEntity = {
  token: "p_3zrzmjrcah",
  type: "product",
  name: "Neon Gummi Worms",
  brandToken: "b_mukk4ka83q",
  brandName: "The Penny Candy Store",
  imageUrl:
    "https://cdn.faire.com/fastly/b98003eb76231a5cb79acb6b47541f9a1672ae2bf8c4d97e3eeb91a5c8179088.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8d6350dc1d0701fa4ba2d5d6cda3500b3a9a3e5b1b12cf1c4a85e7a5064a0b0f.jpeg",
    "https://cdn.faire.com/fastly/e185ff7ac9b104d54f16b3b947be62fe3985e1cb0801ec63ae8bdbbfeb9617aa.jpeg",
    "https://cdn.faire.com/fastly/077c8eccbf7f5bcbf974a5825424b49a69315d4f1bd3e5de4a3e80578d7dae37.jpeg",
  ],
  priceDollars: 2.29,
  description:
    "Enjoy Neon Gummi Worms, a Gummy treat from The Penny Candy Store. Using recyclable packaging, these USA-made treats promote sustainability over a 12-24 month shelf life.",
  tags: [],
  msrpDollars: 4.16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:07.540Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
